import * as React from 'react'
import slugify from 'slugify'
import ImageWithCaption from 'components/common/ImageWithCaption'
import YouTubeEmbed from 'components/common/YouTubeEmbed'
import IframeVideoEmbed from 'components/common/IframeVideoEmbed'
import InlineImage from './InlineImage'
import DotLeaderList from 'components/common/DotLeaderList'
import EmbedForm from 'components/form/EmbedForm'
import StatGrid from 'components/common/StatGrid'
import RichtextCTA from 'components/blocks/RichtextModule/RichtextCTA'
import BlockContent from '@sanity/block-content-to-react'
import newtab from 'utils/newtab'
import clsx from 'clsx'
import { getTextContent } from 'utils/getTextContent'

const sanityConfig = {
	projectId: process.env.GATSBY_SANITY_PROJECT_ID,
	dataset: process.env.GATSBY_SANITY_DATASET,
}

const SanityBlock = ({ body, components, className }) =>
	!!body && (
		<BlockContent
			{...sanityConfig}
			blocks={body}
			serializers={{ ...serializers, ...components }}
			className={clsx(className, 'richtext')}
			renderContainerOnSingleChild
		/>
	)

export default SanityBlock

const serializers = {
	types: {
		block: (props) => {
			const { style } = props.node

			switch (style) {
				case 'h1':
				case 'h2':
				case 'h3':
				case 'h4':
				case 'h5':
				case 'h6':
					const hdg = getTextContent(props.children)

					return React.createElement(
						style,
						{
							className: style,
							id: !!hdg && slugify(hdg, { lower: true, remove: /’/g }),
						},
						props.children,
					)

				default:
					return BlockContent.defaultSerializers.types.block(props)
			}
		},

		imageWithCaption: ({ node }) => (
			<ImageWithCaption config={sanityConfig} {...node} />
		),
		inlineImage: ({ node }) => <InlineImage config={sanityConfig} {...node} />,
		youtubeEmbed: ({ node }) => <YouTubeEmbed {...node} />,
		iframeVideoEmbed: ({ node }) => <IframeVideoEmbed {...node} />,
		dotLeaderList: ({ node }) => <DotLeaderList {...node} />,
		embedForm: ({ node }) => <EmbedForm {...node} />,
		'stat-grid': ({ node }) => <StatGrid {...node} config={sanityConfig} />,
		'richtext-cta': ({ node }) => <RichtextCTA {...node} />,
	},

	marks: {
		link: ({ mark, children }) => {
			const external = mark.href?.startsWith('http') ? newtab : {}
			return (
				<a className="link" href={mark.href} {...external}>
					{children}
				</a>
			)
		},
	},
}
